// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"732bb8ea","239":"835ebee7","453":"d20bbbaa","732":"c4465977"}[chunkId] + ".chunk.js";
};